// Selectable models for admin dropdowns — the offered set only (mirrors the backend VALID_MODELS).
// Retired ids (e.g. gemini-2.5-pro) are intentionally NOT listed so we don't offer a model we silently
// auto-replace. Any already-stored value still works: the backend keeps it in ModelSchema and dispatch
// redirects it to its replacement.
export const MODEL_OPTIONS = [
  { value: "gpt-4.1", label: "GPT-4.1" }, // hardcoded in: document summarization, memo engine, intelligence, chapters, team member extraction; default model in createProject store; web search capable
  { value: "gpt-4.1-mini", label: "GPT-4.1 Mini" }, // chat only
  { value: "gpt-4.1-nano", label: "GPT-4.1 Nano" }, // used in document summarization (chunk classification)
  { value: "gpt-5", label: "GPT-5" }, // web search capable
  { value: "gpt-5-mini", label: "GPT-5 Mini" }, // chat only
  { value: "gpt-5.4", label: "GPT-5.4" }, // hardcoded in: askProjectResponse, generateSlidesUpdate; web search capable
  { value: "gpt-5.4-mini", label: "GPT-5.4 Mini" }, // chat only
  { value: "gpt-5.4-nano", label: "GPT-5.4 Nano" }, // chat only
  { value: "gpt-5.5", label: "GPT-5.5" }, // web search capable
  { value: "gemini-3.5-flash", label: "Gemini 3.5 Flash" }, // chat only
  { value: "gemini-3.1-pro-preview", label: "Gemini 3.1 Pro Preview" }, // chat only
  { value: "gemini-3.1-flash-lite", label: "Gemini 3.1 Flash-Lite" }, // chat only
  { value: "claude-opus-5", label: "Claude Opus 5" }, // chat only
  { value: "claude-opus-4-8", label: "Claude Opus 4.8" }, // chat only; refusal fallback for Opus 5
  { value: "claude-sonnet-5", label: "Claude Sonnet 5" }, // chat only
  { value: "claude-sonnet-4-6", label: "Claude Sonnet 4.6" }, // chat only
  { value: "claude-haiku-4-5", label: "Claude Haiku 4.5" } // chat only
] as const;

export type TModelOption = (typeof MODEL_OPTIONS)[number];
